/**
 * @author Ariel
 * @desc 活动公告表单页面
 * @date 2020-09-24
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from '../../../../../tool'
import { WizBraftEditorPlus } from '@/containers/common'
import moment from "moment";
import { log } from "wiz-utils";

let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizSpin, WizForm } = component_tool
let { Session } = utils_tool

class ActivityMessageDetail extends WizContainer {
  componentName = 'activityMessageDetail'

  constructor(props) {
    super(props)
    const { history } = props
    let initialValue = {}
    let cardTitle = '新增'
    if (history.location) {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('initialValue', initialValue)
      } else {
        initialValue = Session.get('initialValue') || {}
      }
      if (history.location.pathname === '/interact/activity/activityMessage/activityMessageDetailUpd') {
        cardTitle = '编辑'
      }
    }
    this.initialValue = initialValue
    this.state = {
      cardTitle,
    }
  }

  _componentDidMount() {
    if (this.initialValue && this.initialValue.id) {
      this.doAction({
        path: 'activityMessage/look',
        payload: {
          key: 'activityMessageInfo',
          apiParams: { id: this.initialValue.id }
        }
      })
    }
  }

  propsAndStateOnChange = {
    addActivityMessage: this._addActivityMessageOver.bind(this),
    activityMessageInfo: this._activityMessageInfoOver.bind(this)
  }

  _addActivityMessageOver(nextProps, nextState) {
    if (nextProps.addActivityMessage.code == 1) {
      wizNotice.success('保存成功');
      let { activityId } = this.initialValue
      this.jumpPage('replace', '/interact/activity/activityMessage', { activityId: activityId });
    } else {
      wizNotice.error('提交失败：' + nextProps.addActivityMessage.msg);
    }
    return true;
  }

  _activityMessageInfoOver(nextProps, nextState) {
    let { activityMessageInfo } = nextProps
    if (activityMessageInfo.code == 1) {
      if (activityMessageInfo && activityMessageInfo.success) {
        this.initialValue = activityMessageInfo.data
      }
    } else {
      wizNotice.error('获取数据失败：' + nextProps.activityMessageInfo.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'activityMessageTime' && value != null && value != undefined) {
        fitterValues['startTime'] = moment(value[0]).format("YYYY-MM-DD 00:00:00")
        fitterValues['endTime'] = moment(value[1]).format("YYYY-MM-DD 23:59:59")
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  _addActivityMessage(values) {
    const { history } = this.props
    let apiPath = 'activityMessage/add';
    if (history.location && history.location.pathname === '/interact/activity/activityMessage/activityMessageDetailUpd') {
      apiPath = 'activityMessage/update'
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addActivityMessage',
        apiParams: {
          ...fitterValues
        }
      }
    })
  }

  _render() {
    const { activityMessageLoading, activityMessageInfo } = this.props
    const { cardTitle } = this.state
    let initialValue = this.initialValue

    let dateFormat = "YYYY-MM-DD"
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: initialValue.id
        }
      },
      {
        name: 'activityId',
        formItem: {
          type: 'hidden',
          initialValue: initialValue.activityId
        }
      },
      {
        title: '公告标题',
        name: 'title',
        formItem: {
          maxLength: 20,
          placeholder: '活动公告标题最多输入20个字',
          initialValue: initialValue.title,
          rules: [
            {
              required: true,
              message: '请输入活动公告标题'
            }
          ],
        }
      },
      {
        title: '有效时间',
        name: 'activityMessageTime',
        formItem: {
          type: 'date~',
          rules: [
            {
              required: true,
              message: '请选择有效时间'
            }
          ],
          format: 'YYYY-MM-DD',
          initialValue: initialValue.startTime ? [moment(initialValue.startTime, dateFormat), moment(initialValue.endTime, dateFormat)] : null
        }
      },
      {
        title: '公告内容',
        name: 'content',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (
              <>
                {getFieldDecorator('content', {
                  initialValue: initialValue.content,
                  rules: [
                    {
                      required: true,
                      message: '请输入活动公告内容'
                    }
                  ],
                })(
                  <WizBraftEditorPlus links={[0, 1, 2, 3]} ref={(r) => { this.editorRef = r && r.getWrappedInstance() }} />
                )}
              </>
            )
          }
        }
      },
      {
        title: '公告状态',
        name: 'state',
        formItem: {
          initialValue: initialValue.state != null ? initialValue.state : 1,
          type: 'radio'
        },
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' }
        ]
      },
    ]
    let onSubmit = this._addActivityMessage.bind(this)
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      onReset: (f) => {
        this.editorRef && this.editorRef.resetContent && this.editorRef.resetContent(f.getFieldValue('content') || '')
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={activityMessageLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { activityMessage } = state;
  const addActivityMessage = modelUtils.getModelEntity(activityMessage, 'addActivityMessage');
  const activityMessageInfo = modelUtils.getModelEntity(activityMessage, 'activityMessageInfo');
  const load = modelUtils.getLoadingState(state, 'activityMessage');
  return {
    addActivityMessage,
    activityMessageInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ActivityMessageDetail);

